import { useEffect, useMemo, useState } from "react";
import { number } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useSnackbar } from "notistack";
import { getCounterQuery } from "@query";
import { JIRA_UPLOAD } from "@utils";
import { Alert } from "@components";
import { Grid, IconButton, LinearProgress } from "@material-ui/core";
import { ErrorList } from "./components/ErrorList";
import { WarningOutlined } from "@material-ui/icons";

export const UploadSnackBar = observer(({
  jiraExportId,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
  const [ counter, setCounter ] = useState(0);
  const [ allIssues, setAllIssues ] = useState(0);
  const [ errors, setErrors ] = useState([]);
  const [ showErrors, setShowErrors ] = useState(false);
  
  const handleShowErrors = (e) => {
    e.stopPropagation();
    setShowErrors(true)
  }
  
  const fetchData = async () => {
    try {
      const response = await getCounterQuery(jiraExportId);
      setCounter(response.percentExported);
      setAllIssues(response.allIssues);
      if(response.errors?.length)
        setErrors(response.errors)
      if (response.percentExported === 100) {
        closeSnackbar(jiraExportId);
        // if(!response.errors.length)
        enqueueSnackbar(t("views.bt.uploaded_successfully"), {
          variant: "success",
          key: JIRA_UPLOAD.SUCCESS,
          preventDuplicate: true,
        });
        // else
        //   enqueueSnackbar(<ErrorAlert errors={response.errors} />, {
        //     variant: "warning",
        //     key: JIRA_UPLOAD.WARNING,
        //     preventDuplicate: true,
        //     persist: true,
        //   });
      }
    } catch {
      closeSnackbar(jiraExportId);
      enqueueSnackbar(t("views.bt.something_went_wrong"), {
        variant: "error",
        key: JIRA_UPLOAD.ERROR,
        preventDuplicate: true,
      });
    }
  };
  
  const fetchDataInterval = useMemo(() => (
    setInterval(fetchData, 5000)
  ), []);
  
  useEffect(() => {
    fetchData();
    return () => clearInterval(fetchDataInterval);
  }, []);

  return (
    <Grid item container className="mx-3">
      <Grid item container alignItems="center" className="mb-2 h-24">
        {t("views.bt.upload_progress", { allIssues: allIssues, exported: counter })}
        {
          Boolean(errors?.length) &&
          <IconButton
            size="small"
            className="ml-2"
            color="secondary"
            onClick={handleShowErrors}
          >
            <WarningOutlined className="color-warning" />
          </IconButton>
        }
      </Grid>
      <LinearProgress value={counter} variant="determinate" color="secondary" />
      <Alert
        isOpen={showErrors}
        title={t("views.bt.upload_alert")}
        acceptText={t("common.close")}
        onAccept={() => setShowErrors(false)}
        width={600}
      >
        <ErrorList errors={errors} />
      </Alert>
    </Grid>
  );
});

UploadSnackBar.propTypes = {
  jiraExportId: number.isRequired,
};
